module.exports = __webpack_public_path__ + "img/section6LegendStar1.313fcf97.svg";